export default "__VITE_ASSET__W4If_iQGJKx75OS3tFZ_6Q__"